export default __webpack_public_path__ + "static/media/feedback-highlights.4ee10613.svg";